<template>
    <Teleport to="#quests">
        <!-- Global notification live region, render this permanently at the end of the document -->
        <div
            aria-live="assertive"
            class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
        >
            <div class="flex w-full flex-col items-center space-y-4 sm:items-end" v-auto-animate>
                <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
                <div
                    v-for="quest in quests"
                    :key="quest.id"
                    class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                >
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900">{{ quest.name }}</p>
                                <div>
                                    <ProgressBarCurrentMax
                                        :current="quest.current"
                                        :max="quest.times_required"
                                        :color="quest.current === quest.times_required ? 'green' : 'blue'"
                                    />
                                </div>
                            </div>
                            <div class="ml-4 flex flex-shrink-0">
                                <button
                                    type="button"
                                    @click="hide(quest)"
                                    class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                    <span class="sr-only">{{ $t('messages.close') }}</span>
                                    <IconX class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { IconX } from '@tabler/icons-vue';
import ProgressBarCurrentMax from '@/components/Gamification/ProgressBarCurrentMax.vue';

export default {
    components: {
        ProgressBarCurrentMax,
        IconX,
    },
    data() {
        return {
            show: true,
            quests: [],
        };
    },
    watch: {
        '$page.props.flash.quests': {
            handler(value) {
                setTimeout(() => {
                    this.quests = value;
                }, 250);
                setTimeout(() => {
                    this.quests.forEach((q) => {
                        q.current = q.counter;
                    });
                }, 1000);
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        hide(quest) {
            this.quests = this.quests.filter((q) => q.id !== quest.id);
        },
    },
};
</script>
